var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity',{attrs:{"entity":"components","presentation":"blank","params":{ 'dh-component-id': _vm.component }}})
}
var staticRenderFns = []

export { render, staticRenderFns }